import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivateFn, CanActivateChildFn, CanMatchFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '@app/core/auth/auth.service';
import { switchMap } from 'rxjs/operators';

/**
 * Check the authenticated status
 */
function checkNoAuth(): Observable<boolean>
{
    const authService = inject(AuthService);
    const router = inject(Router);

    // Check the authentication status
    return authService.check()
               .pipe(
                   switchMap((authenticated) => {

                       // If the user is authenticated...
                       if ( authenticated )
                       {
                           // Redirect to the root
                           router.navigateByUrl(authService.landingPage);

                           // Prevent the access
                           return of(false);
                       }

                       // Allow the access
                       return of(true);
                   })
               );
}

/**
 * Can activate functional guard
 */
export const canActivateNoAuth: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return checkNoAuth();
};

/**
 * Can activate child functional guard
 */
export const canActivateChildNoAuth: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return checkNoAuth();
};

/**
 * Can match functional guard
 */
export const canMatchNoAuth: CanMatchFn = (route, segments) => {
    return checkNoAuth();
};

// Legacy class-based guard (deprecated - use functional guards above)
// @deprecated Use canActivateNoAuth, canActivateChildNoAuth, canMatchNoAuth instead
export { canActivateNoAuth as NoAuthGuard }
